module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vsens26-bc32fc5302947aad6c6447b04b6d9712.jpg";